import * as Cookies from 'js-cookie'
import chatRoomLobby from './components/chat-room-lobby'
import chatMessageContainer from './components/chat-message-container'

  /* eslint-disable */
const changeChatRoom = (to, from, next) => {
  // console.log('changeRoom: ' + window.connect_mode, ' / site_id: ' + window.site_id, ' / Cookies: ' + Cookies.get('site_id'), to, from)
  if (window.connect_mode === 'first' || window.parent === window) {
    // console.log('[connect_mode is first / not in frame]')
    location.replace(location.href.slice(0, location.href.lastIndexOf('/')) + window.site_id)
    next()
  }
  var siteID = to.path.replace('/', '')
  if (siteID === '') {
    siteID = Cookies.get('site_id')
  }
  if (siteID && siteID !== window.site_id) {
    // alert('채널 변경 ' + window.site_id + ' ==> ' + siteID)
    // console.log(window.site_id, window.channel_names, window)
    window.site_id = siteID
    window.channel_name = window.channel_names[siteID]
    window.force_disconnect()
    if (window.chattingApp !== undefined) {
      window.chattingApp.$store.dispatch('clearMessages')
    } else {
      // setTimeout(function () {
      //   if (window.chattingApp !== undefined) {
      //     window.chattingApp.$store.dispatch('clearMessages')
      //   }
      // }, 100)
    }
    window.connect(true, undefined, 'router.js if ' + document.readyState, )
    Cookies.set('site_id', siteID, { path: '/', expires: 365 })
  }
  next()
}

export default [
  {
    path: '/lottery',
    name: 'openchatting-lottery',
    component: chatMessageContainer,
    beforeEnter: (to, from, next) => {
      // console.log('openchatting-fxgame')
      changeChatRoom(to, from, next)

    }
  },
  {
    path: '/fxgame',
    name: 'openchatting-fxgame',
    component: chatMessageContainer,
    beforeEnter: (to, from, next) => {
      // console.log('openchatting-fxgame')
      changeChatRoom(to, from, next)

    }
  },
  {
    path: '/localhost',
    name: 'openchatting-sport',
    component: chatMessageContainer,
    beforeEnter: (to, from, next) => {
      // console.log('openchatting-sport')
      changeChatRoom(to, from, next)
    }
  },
  {
    path: '/esports',
    name: 'openchatting-legleg',
    component: chatMessageContainer,
    beforeEnter: (to, from, next) => {
      // console.log('openchatting-legleg')
      changeChatRoom(to, from, next)

    }
  },
  {
    path: '/racing',
    name: 'openchatting-racing',
    component: chatMessageContainer,
    beforeEnter: (to, from, next) => {
      // console.log('openchatting-racing')
      changeChatRoom(to, from, next)

    }
  },
  {
    path: '/game',
    name: 'openchatting-ladder',
    component: chatMessageContainer,
    beforeEnter: (to, from, next) => {
      // console.log('openchatting-ladder')
      changeChatRoom(to, from, next)
    }
  },
  {
    path: '/fireworks',
    name: 'openchatting-fireworks',
    component: chatMessageContainer,
    beforeEnter: (to, from, next) => {
      // console.log('openchatting-fireworks')
      changeChatRoom(to, from, next)

    }
  },
  {
    path: '/lobby',
    name: 'chatroomlobby',
    component: chatRoomLobby,
    beforeEnter: (to, from, next) => {
      // console.log('chatroomlobby')
      changeChatRoom(to, from, next)

    }
  },
  {
    path: '/',
    redirect: ('/' + window.site_id),
    beforeEnter: (to, from, next) => {
      // console.log('/', window.site_id)
    }
  },
  {
    path: '*',
    redirect: ('/' + window.site_id),
    beforeEnter: (to, from, next) => {
      // console.log('*', window.site_id)
    }
  }
]




// WEBPACK FOOTER //
// ./src/routes.js